var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"overlay",on:{"click":_vm.closeEverything}})
}
var staticRenderFns = []

export { render, staticRenderFns }